import * as React from 'react'

interface IProps {
  text: string
  children?: React.ReactNode
}

export default function SectionLabel({ text, children }: IProps): JSX.Element {
  return (
    <div className="tw:pb-1 tw:inline-flex tw:items-center tw:gap-2">
      <span className="tw:text-sm tw:font-medium tw:leading-5 tw:text-muted-foreground">
        {text}:
      </span>
      {children}
    </div>
  )
}
